export const STORAGE_CONST = {
  // CURRENT_SHORTSTAY_SEARCH: 'CURRENT_SHORTSTAY_SEARCH',
  // PREVIOUS_SHORTSTAY_SEARCHES: 'PREVIOUS_SHORTSTAY_SEARCHES',
  // SHORTSTAY_SETTINGS: 'SHORTSTAY_SETTINGS',
  FIREBASE_AUTH_TOKEN: 'FT',
  AUTH_TOKEN: 'AT',
  REFRESH_TOKEN: 'RT',
  // FAVOURITE_SHORTSTAY_PROPERTIES: 'FAVOURITE_SHORTSTAY_PROPERTIES',
  MOBILE_SEO_DATA_: 'MSD_',
  WEB_SEO_DATA_: 'WSD_',
  LAST_CACHE_VERSION: 'LCV',
  CURRENT_CACHE_VERSION: 'CCV',
  SEO_CACHE_PREFIX_ENUM: 'fe_seo_',
  DYNAMIC_CACHE_PREFIX_ENUM: 'fe_dyn_',
  SEO_CACHE_SUFFIX_ENUM: '_ch',
  DESKTOP_PAGE_DATA_CACHE_PREFIX_ENUM: 'fe_desk_pg_lcd_',
  MOBILE_PAGE_DATA_CACHE_PREFIX_ENUM: 'fe_mob_pg_lcd_',
  MOBILE_APP_PAGE_DATA_CACHE_PREFIX_ENUM: 'fe_mob_app_pg_d_',
  PAGE_DATA_CACHE_SUFFIX_ENUM: '_ch',
};
